import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
} from 'antd';

const ConfirmationModal = (props) => {
  const {
    handleCancel, handleOk, title, content, visible,
  } = props;

  return (
    <Modal
      className="platform-management-modal"
      title={title}
      visible={visible}
      onOk={handleOk}
      footer={null}
      onCancel={handleCancel}
    >
      {content}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: 20,
        }}
      >
        <Button
          type="link"
          className="link-button white"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          className="configure-button"
          onClick={handleOk}
        >
          Continue
        </Button>
      </div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  visible: PropTypes.bool.isRequired,
};

ConfirmationModal.defaultProps = {
  title: '',
  content: '',
};

export default ConfirmationModal;
